import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Homepage from "./Homepage";
import Contacts from "./Contacts";
import About from "./About";
import Stream from "./Stream";
import Shop from "./Shop";
import Videos from "./Videos";
import Music from "./Music";
import Blog from "./Blog";
import UploadFiles from "./UploadFiles";
import Login from "./Login"


const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Homepage} />
        <Route exact  path="/contacts" component={Contacts} />
        <Route exact  path="/about" component={About} />
        <Route exact path="/stream" component={Stream}/>
        <Route exact path="/shop" component={Shop}/>
        <Route exact path="/music" component={Music}/>
        <Route exact path="/videos" component={Videos}/>
        <Route exact path="/blog" component={Blog}/>
        <Route exact path="/ups" component={Login}/>
        <Route exact path="/upload" component={UploadFiles}/>
      </Switch>
    </Router>
  );
};
export default Routes;
